/**
 * Folder color mapping matching backend VALID_COLORS.
 * Uses concrete Tailwind class strings (no template literals) for correct purging.
 */

export interface FolderColorSet {
  bg: string
  dot: string
  text: string
  ring: string
}

export const FOLDER_COLORS: Record<string, FolderColorSet> = {
  gray: { bg: 'bg-gray-100 dark:bg-gray-800', dot: 'bg-gray-500', text: 'text-gray-600', ring: 'ring-gray-400' },
  blue: { bg: 'bg-blue-100 dark:bg-blue-900', dot: 'bg-blue-500', text: 'text-blue-600', ring: 'ring-blue-400' },
  green: { bg: 'bg-green-100 dark:bg-green-900', dot: 'bg-green-500', text: 'text-green-600', ring: 'ring-green-400' },
  yellow: { bg: 'bg-yellow-100 dark:bg-yellow-900', dot: 'bg-yellow-500', text: 'text-yellow-600', ring: 'ring-yellow-400' },
  orange: { bg: 'bg-orange-100 dark:bg-orange-900', dot: 'bg-orange-500', text: 'text-orange-600', ring: 'ring-orange-400' },
  red: { bg: 'bg-red-100 dark:bg-red-900', dot: 'bg-red-500', text: 'text-red-600', ring: 'ring-red-400' },
  purple: { bg: 'bg-purple-100 dark:bg-purple-900', dot: 'bg-purple-500', text: 'text-purple-600', ring: 'ring-purple-400' },
  pink: { bg: 'bg-pink-100 dark:bg-pink-900', dot: 'bg-pink-500', text: 'text-pink-600', ring: 'ring-pink-400' },
}

export const VALID_COLORS = ['gray', 'blue', 'green', 'yellow', 'orange', 'red', 'purple', 'pink'] as const

export type FolderColor = (typeof VALID_COLORS)[number]
